import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand } from 'react-icons/tb';
import { useSidebarToggle } from '../hooks/useSidebarToggle';

interface SidebarToggleButtonProps {
	sx?: any;
}

export const SidebarToggleButton: React.FC<SidebarToggleButtonProps> = ({ sx = {} }) => {
	const { isCollapsed, toggleSidebar } = useSidebarToggle();

	return (
		<Tooltip title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'} arrow>
			<IconButton
				onClick={toggleSidebar}
				sx={{
					p: 1,
					border: '1px solid',
					borderColor: 'divider',
					bgcolor: 'background.paper',
					color: 'text.secondary',
					'&:hover': {
						bgcolor: 'action.hover',
						borderColor: 'action.focus',
					},
					transition: 'all 0.2s ease-in-out',
					...sx,
				}}
				aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
			>
				{isCollapsed ? (
					<TbLayoutSidebarLeftExpand size={20} />
				) : (
					<TbLayoutSidebarLeftCollapse size={20} />
				)}
			</IconButton>
		</Tooltip>
	);
};
